import axios from 'axios'

const api = axios.create({
  baseURL: 'http://localhost:8888', // our server base URL
  headers: {
    'Content-Type': 'application/json',
    'X-Source-Country': localStorage.getItem('location') || '',
  },
})

const handleResponse = (response) => response.data

export const setHeaderLocation = (location) => {
  api.defaults.headers['X-Source-Country'] = location
}

const handleError = (error) => {
  console.error('API call error:', error)
  throw error
}

export const getData = (endpoint) =>
  api.get(endpoint).then(handleResponse).catch(handleError)

export const postData = (endpoint, data) =>
  api.post(endpoint, data).then(handleResponse).catch(handleError)

export default api
